import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import { Row, Col, Input, Spin } from "antd";
import { Creators as ManufacturerActions } from "../../../store/ducks/manufacturer";
import ButtonStandard from "../../utils/button";
import { Container, Footer } from "./styles";

const INITIAL_VALUES = { name: "" };

const validationSchema = Yup.object().shape({
  name: Yup.string().required().trim(),
});

function DrawerManufacturer() {
  const dispatch = useDispatch();

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
    translation,
  } = useSelector((state) => state.app);

  const { drawerVisible, isLoadingRequest } = useSelector(
    (state) => state.manufacturer,
  );

  return (
    <Formik
      enableReinitialize
      initialValues={INITIAL_VALUES}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => {
        dispatch(
          ManufacturerActions.saveManufacturer(groupId, farmId, {
            name: values.name.trim(),
            status: "Active",
          }),
        );
        resetForm();
      }}
    >
      {({
        values,
        errors,
        submitCount,
        setFieldValue,
        handleSubmit,
        resetForm,
      }) => {
        const handleClose = () => {
          resetForm();
          dispatch(ManufacturerActions.hideDrawer());
        };

        return (
          <Container
            title={translation.manufacturer.drawerTitle}
            zIndex={1013}
            width={400}
            onClose={handleClose}
            maskClosable={false}
            visible={drawerVisible}
          >
            <Spin spinning={isLoadingRequest}>
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="drawerForm">
                  <Row type="flex">
                    <Col span={24}>
                      <span style={{ fontSize: 14, color: "#000" }}>
                        {translation.manufacturer.drawerSubTitle}
                      </span>
                    </Col>
                  </Row>
                  <Row type="flex" style={{ marginTop: 13 }} align="middle">
                    <Col span={24}>
                      <Row>
                        <label
                          className={
                            errors.name && submitCount > 0 ? "error" : ""
                          }
                        >
                          {translation.manufacturer.form.name}*
                        </label>
                      </Row>
                      <Row>
                        <Input
                          placeholder={
                            translation.manufacturer.form.namePlaceHolder
                          }
                          value={values.name}
                          name="name"
                          autoComplete="chrome-off"
                          onChange={(e) =>
                            setFieldValue("name", e.target.value)
                          }
                        />
                      </Row>
                    </Col>
                  </Row>
                </div>
                <Footer>
                  <Row type="flex" justify="end">
                    <Col className="buttonsDiv">
                      <ButtonStandard
                        type="button"
                        buttonType="type7"
                        onClick={handleClose}
                      >
                        {translation.buttons.cancel}
                      </ButtonStandard>
                      <ButtonStandard buttonType="type6" type="submit">
                        {translation.buttons.save}
                      </ButtonStandard>
                    </Col>
                  </Row>
                </Footer>
              </form>
            </Spin>
          </Container>
        );
      }}
    </Formik>
  );
}

export default DrawerManufacturer;
